
export class NumberRangeHelper {
    public static minPositiveValue = () => 0
    public static maxAvailableValue = () => 2147483647
    public static million = () => 1000000
}
